import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import Icon from 'presentation/icons';
import { ProtocolItemContent, ProtocolItemHeader } from './components';
import {
	StyledAccordion,
	StyledAccordionDetails,
	StyledAccordionSummary,
} from './styles';
import type { ProtocolItemAccordionProps } from './types';

export function ProtocolItemAccordion({
	title,
	requestedAt,
	valueInformed,
	providerName,
	fiscalDocNumber,
	isRefund,
	selected,
	onSelect,
	error,
}: ProtocolItemAccordionProps) {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<StyledAccordion
			disableGutters
			expanded={isRefund ? true : expanded}
			onChange={isRefund ? undefined : (_: unknown, isExpanded: boolean) => setExpanded(isExpanded)}>
			<StyledAccordionSummary
				$isRefund={isRefund}
				expandIcon={
					isRefund ? null : (
						<Icon name="expand-more-filled" color={theme.palette.primary.main} size={24} />
					)
				}
				aria-controls="protocol-content"
				id="protocol-header">
				<ProtocolItemHeader
					title={title}
					requestedAt={requestedAt}
					valueInformed={valueInformed}
					isRefund={isRefund}
					selected={selected}
					onSelect={onSelect}
					error={error}
				/>
			</StyledAccordionSummary>
			<StyledAccordionDetails $isRefund={isRefund}>
				<ProtocolItemContent providerName={providerName} fiscalDocNumber={fiscalDocNumber} />
			</StyledAccordionDetails>
		</StyledAccordion>
	);
}
